module.exports = __webpack_public_path__ + "static/media/aws.7fcc3b8f.png";